import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectResendLoading = (store: StoreSchema) => store.loginState.resendLoading